import { Link, Location } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SidePanelSection from "./../../../SidePanelSection/SidePanelSection";
import QueryLoader from "components/QueryLoader";
import { libraryObjectsQuery } from "services/content";
import { LibraryObject } from "services/content/model";
import {
  buildExerciseSourcePath,
  isExerciseSourceActive,
} from "pages/Exercises/urlState";

type Props = {
  location: Location;
};

export default function SourceSection(props: Props) {
  const { t } = useTranslation();

  return (
    <QueryLoader query={libraryObjectsQuery()}>
      {objects => (
        <SidePanelSection
          sectionTitle={t("Common.labels.source")}
          list={objects.list}
          location={props.location}
          tagName={SourceListItem}
        />
      )}
    </QueryLoader>
  );
}

type SourceListItemProps = {
  item: LibraryObject;
  location?: Location;
};

function SourceListItem(props: SourceListItemProps) {
  const path = buildExerciseSourcePath(props.item.id);
  const isActive =
    props.location !== undefined && isExerciseSourceActive(props.location, props.item.id);
  return (
    <li className={isActive ? "active" : ""}>
      <Link to={path}>{props.item.name}</Link>
    </li>
  );
}
